
export function cdnPath (path, o = {}) {
    const params = new URLSearchParams();
    Object.keys(o).forEach((k) => {
        params.append(k, o[k]);
    })
    const append = params.toString();
    if (append.length === 0) return path;
    return path + '?' + append;
}



// WEBPACK FOOTER //
// ./src/helpers/cdn-helper.js